export default "__VITE_ASSET__D4ELjf24__"